import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { environment } from "~/environments/environment";
import { map, Observable } from "rxjs";
import { ErrorService } from "./error.service";
import { DatePipe } from "@angular/common";


@Injectable({
    providedIn: 'root'
})
export class OnBaseService {
    private readonly BASE_URL: string = environment.onBaseURL;

    private readonly INVOICES: string = this.BASE_URL + environment.onBaseInvoices;
    private readonly PARENTS: string = this.BASE_URL + environment.onBaseParents;
    private readonly USER: string = environment.onBaseUser;

    constructor(public baseService: BaseService, 
                public errorService: ErrorService,
                private datepipe: DatePipe) {
    }

    public getDocPopURLByInvoiceList(invoiceIds: string[]): Observable<string[]> {
        let invoices = invoiceIds.join(",");
        return this.baseService.postHttpObject<any>(
            'getDocPopURLByInvoiceListWS', 
            'OnBaseService', 
            this.BASE_URL + "documents",
            { invoices: invoices },
            { observe: "response" }
        ).pipe(map(res => {
            return res["body"];
        }));
    }

    public getDocPopURLByInvoiceListStream(invoiceIds: string[]): Observable<any> {
        let invoices = invoiceIds.join(",");
        let url = this.BASE_URL + "document-stream";

        return this.baseService.postHttpObject<any>(
            'getDocPopURLByInvoiceListStream',
            'OnBaseService',
            url,
            { invoices: invoices },
            {
                observe: 'events',
                responseType: 'text',
                reportProgress: true
            }
        )
    }

    public getDocPopURLByBulkParents(parentNumbers: string[], from: Date, to: Date) {
        let parentList = parentNumbers.map(x => {
            return {
                ParentNum: x
            }
        });

        return this.baseService.postHttpObject<any>(
            'getDocPopURLByBulkParents',
            'OnBaseService',
            this.PARENTS,
            {
                Username: this.USER,
                FromInvoiceDate: this.datepipe.transform(from, "MM/dd/yyyy"),
                ToInvoiceDate: this.datepipe.transform(to, "MM/dd/yyyy"),
                Parents: parentList
            },
            { observe: "response" }
        ).pipe(map(res => res["body"]));
    }

    public getDocPopURLByBulkStores(storeNumbers: string[], from: Date, to: Date) {}
}